import { render, staticRenderFns } from "./workWithCultures.vue?vue&type=template&id=45e8a699"
import script from "./workWithCultures.vue?vue&type=script&lang=js"
export * from "./workWithCultures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports